import React, { Component } from 'react'

import Input from 'shared-web/src/components/Input'
import CheckBox from 'shared-web/src/components/CheckBox'

import colors from 'styles/colors'

const AttributeList = ({ title, rows, editing }) => {
  const attributes = rows
    .map(({ value, ...rest }) => ({
      value: typeof value === 'boolean' ? `${value}` : value,
      ...rest,
    }))
    .map((props, i) => (
      <Attribute
        key={i}
        {...props}
        offWhiteBackground={i % 2 !== 0}
        editing={editing}
      />
    ))
  return (
    <div style={{ padding: '15px 0' }}>
      <span className="dsg-Title">{title}</span>
      {attributes}
    </div>
  )
}

export default AttributeList

class Attribute extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isInput: null,
    }
  }

  getInputValue() {
    const { value, handleChange } = this.props
    return (
      <Input
        className="flex-1"
        isValid={value ? value.length > 0 : true}
        valueLink={{ value, requestChange: handleChange }}
        size="small"
      />
    )
  }

  getReadOnlyValue() {
    return <div className="flex-1 dsg-body color-navy-dark">{this.props.value}</div>
  }

  getLinkValue() {
    return (
      <a className="flex-1" href={this.props.href} target="_blank">
        <div className="dsg-Body truncate">{this.props.value}</div>
      </a>
    )
  }

  getNormalValue() {
    const { value } = this.props
    return (
      <div className="flex-1 dsg-Body">
        {typeof value === 'boolean' ? JSON.stringify(value) : value }
      </div>
    )
  }

  render() {
    const { label, offWhiteBackground, href, editing, handleChange, handleCheckBoxChange, checked } = this.props
    const displayValue = editing
      ? (handleChange ? this.getInputValue() : this.getReadOnlyValue())
      : (href ? this.getLinkValue() : this.getNormalValue())
    return (
      <div
        className="flex-start"
        style={{
          padding: `${(editing && handleChange) ? 0 : 12}px 10px`,
          alignItems: 'center',
          backgroundColor: offWhiteBackground ? colors['color-navy-off-white'] : undefined,
        }}
      >
        <div
          className="dsg-Small color-navy-dark dsg-medium-weight"
          style={{ width: 150, paddingRight: 10, wordWrap: 'break-word' }}
        >
          {label}
        </div>
        {displayValue}
        {editing &&
          <div style={{ paddingLeft: 5 }}>
            <CheckBox
              id={label}
              checked={checked}
              onChange={handleCheckBoxChange}
            />
          </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserAttributesCard/AttributesModal/Category/index.js